import React from 'react'
import NavBarLink from '../../Layout/shared/NavBarLink'

import { REGISTRATIONS_ROOT } from './routePaths'

const RegistrationNavbarLink = () => <NavBarLink path={REGISTRATIONS_ROOT} title="Registrations" />

export default RegistrationNavbarLink
